import { useEffect, useMemo, useState } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { Marker, Pane, Popup } from "react-leaflet";
import { divIcon } from "leaflet";
import _ from "lodash";
import { Box, Button, Card, Stack, Typography } from "@mui/material";

import { getLocationData } from "Helper/map";
import { STATIONS_COLOR, STATIONS_SIZE } from "Configs/map";
import { STATIONS } from "Constants/Stations";
import { IStation } from "Types/station";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

export default function Station2({
  singleStationData,
  setFormData,
  editLocMode,
  isEdit,
}: {
  singleStationData?: any;
  setFormData?: any;
  editLocMode?: boolean;
  isEdit?: boolean;
}) {
  const dispatch = useAppDispatch();
  const { type, name } = useAppSelector((state) => state.operation);
  const { visibility } = useAppSelector((state) => state.filters);
  const { stationLayer } = useAppSelector((state) => state.layers);
  const { stationLoc } = useAppSelector((state) => state.map);
  const [lastCenter2, setLastCenter2] = useState({ lat: 0, lng: 0 });

  let timeHolder: any;

  // useEffect(() => {
  //   setLastCenter2({ lat: singleStationData[0]?.lat, lng: singleStationData[0]?.lng });
  // }, [singleStationData]);

  const stationsMarker = useMemo(() => {
    // return;
    if (singleStationData.length === 0 || !editLocMode) return;
    const finalStations: IStation[] = singleStationData;

    return finalStations.map((station) => {
      let position: any;
      if (isEdit) {
        if (lastCenter2?.lat === 0 && lastCenter2?.lng === 0) {
          position = [station?.lat, station?.lng];
        } else {
          position = lastCenter2;
        }
      } else {
        position = [stationLoc?.lat, stationLoc?.lng];
      }

      if (!station) return;
      const stationColor = STATIONS_COLOR[station.type];
      const stationData = STATIONS.filter((i) => i.type === station.type)[0];

      const iconMarkup = renderToStaticMarkup(
        <Box
          style={{
            width: `${STATIONS_SIZE}px`,
            height: `${STATIONS_SIZE}px`,
            backgroundColor: stationColor,
            borderRadius: "50%",
            border: "4px solid #F5F5F5",
            display: "grid",
            placeItems: "center",
            color: "#fff",
          }}
        >
          {stationData.icon}
        </Box>
      );
      const icon = divIcon({
        html: iconMarkup,
        iconAnchor: [STATIONS_SIZE / 2, STATIONS_SIZE / 2],
      });

      return (
        <Marker
          key={station.id}
          position={position}
          icon={icon}
          zIndexOffset={1}
          draggable={true}
          eventHandlers={{
            drag: (e: any) => {
              clearTimeout(timeHolder);
              setLastCenter2(e.latlng);
              timeHolder = setTimeout(() => {
                getLocationData({ lat: e.latlng.lat, lng: e.latlng.lng }).then((res: any) => {
                  setFormData((prev: any) => ({ ...prev, address: res.formattedAddress }));
                });
                setFormData({ ...singleStationData[0], lat: e.latlng.lat, lng: e.latlng.lng });
              }, 500);
            },
          }}
        />
      );
    });
  }, [type, visibility, singleStationData, editLocMode]);

  return (
    <>
      {" "}
      <Pane style={{ zIndex: stationLayer }} name="show-stations" key={stationLayer}>
        {stationsMarker}
      </Pane>
      any
    </>
  );
}
